import { Trace } from './trace.model';

export interface AnalyticsRequest {
  fingerprint: string;
  traces: Trace[];
}
